export default __webpack_public_path__ + "static/img-5-59d6cc917e80ad626f0dc8eac5548449.png";